var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FeedbackFormBuilder_instances, _FeedbackFormBuilder_components, _FeedbackFormBuilder_title, _FeedbackFormBuilder_getBuilderConstructor;
import { ComponentType } from './types';
import { SegmentedToggleComponentBuilder, DropdownComponentBuilder, FacesRatingBarComponentBuilder, TextInputComponentBuilder, } from './builders';
export class FeedbackFormBuilder {
    constructor(id) {
        _FeedbackFormBuilder_instances.add(this);
        this.id = id;
        _FeedbackFormBuilder_components.set(this, []);
        // TODO: remove default value
        _FeedbackFormBuilder_title.set(this, 'Form');
    }
    setTitle(title) {
        __classPrivateFieldSet(this, _FeedbackFormBuilder_title, title, "f");
        return this;
    }
    addRow(type, id, cb) {
        const BuilderConstructor = __classPrivateFieldGet(this, _FeedbackFormBuilder_instances, "m", _FeedbackFormBuilder_getBuilderConstructor).call(this, type);
        const builder = new BuilderConstructor(id);
        // @ts-expect-error TODO: fix type issue
        cb(builder);
        const validation = builder.isValid();
        if (!validation.valid) {
            const base = [
                `Invalid builder. Id: ${validation.id}, Type: ${validation.type}`,
            ];
            const messages = validation.messages
                .map((message) => {
                return `- ${message}`;
            })
                .join('\n');
            throw new Error([base, messages].join('\n'));
        }
        __classPrivateFieldGet(this, _FeedbackFormBuilder_components, "f").push(builder.build());
        return this;
    }
    addTextInput(id, cb) {
        return this.addRow(ComponentType.TextInput, id, cb);
    }
    addDropdown(id, cb) {
        return this.addRow(ComponentType.Dropdown, id, cb);
    }
    addSegmentedToggle(id, cb) {
        return this.addRow(ComponentType.SegmentedToggle, id, cb);
    }
    addFacesRatingBar(id, cb) {
        return this.addRow(ComponentType.FacesRatingBar, id, cb);
    }
    isValid() {
        if (!this.id || !__classPrivateFieldGet(this, _FeedbackFormBuilder_title, "f")) {
            return false;
        }
        if (!__classPrivateFieldGet(this, _FeedbackFormBuilder_components, "f").length) {
            return false;
        }
        return true;
    }
    build() {
        return {
            id: this.id,
            title: __classPrivateFieldGet(this, _FeedbackFormBuilder_title, "f"),
            components: __classPrivateFieldGet(this, _FeedbackFormBuilder_components, "f"),
        };
    }
}
_FeedbackFormBuilder_components = new WeakMap(), _FeedbackFormBuilder_title = new WeakMap(), _FeedbackFormBuilder_instances = new WeakSet(), _FeedbackFormBuilder_getBuilderConstructor = function _FeedbackFormBuilder_getBuilderConstructor(type) {
    switch (type) {
        case ComponentType.Dropdown:
            return DropdownComponentBuilder;
        case ComponentType.FacesRatingBar:
            return FacesRatingBarComponentBuilder;
        case ComponentType.SegmentedToggle:
            return SegmentedToggleComponentBuilder;
        case ComponentType.TextInput:
            return TextInputComponentBuilder;
    }
};
//# sourceMappingURL=form.js.map